import { render, staticRenderFns } from "./application-pages.component.vue?vue&type=template&id=2998b9b6"
import script from "./application-pages.component.ts?vue&type=script&lang=ts&external"
export * from "./application-pages.component.ts?vue&type=script&lang=ts&external"
import style0 from "./application-pages.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports